import React, { FC, useMemo } from 'react';

import { useApolloClient } from '@apollo/react-hooks';

import { makeFrame, ForgeUIRenderer } from '@atlassian/forge-ui/ui';

import { ForgeUIKitRendererProps } from '../../types';
import { FORGE_PRODUCT } from '../../utils/context';
import { ForgeIframeRenderer } from '../ForgeIframeRenderer/ForgeIframeRenderer';

export const ForgeUIKit2Renderer: FC<ForgeUIKitRendererProps> = ({
  app,
  bridge,
  components,
  contextIds,
  coreData,
  currentUser,
  entryPoint,
  extensionData,
  locale,
  getContextToken,
  onInitialRender,
}) => {
  const { localId, workspaceId } = coreData;
  const apolloClient = useApolloClient();

  const wiredComponents = useMemo(
    () => ({
      // `UserPicker` is not supported in Forge UI Kit 2. See https://ecosystem-platform.atlassian.net/browse/EXT-1557
      ...components,
      Frame: makeFrame(({ resource }) => {
        return (
          <ForgeIframeRenderer
            app={{
              ...app,
              properties: {
                ...app.properties,
                resource,
              },
            }}
            bridge={bridge}
            contextIds={contextIds}
            coreData={coreData}
            currentUser={currentUser}
            extensionData={extensionData}
            getContextToken={getContextToken}
            onInitialRender={onInitialRender}
          />
        );
      }),
    }),
    [
      app,
      bridge,
      components,
      contextIds,
      coreData,
      currentUser,
      extensionData,
      getContextToken,
      onInitialRender,
    ]
  );

  return (
    <ForgeUIRenderer
      accountId={currentUser?.account_id}
      bridge={bridge}
      client={apolloClient}
      components={wiredComponents}
      contextIds={contextIds}
      entryPoint={entryPoint}
      extension={app}
      extensionData={extensionData}
      getContextToken={getContextToken}
      localId={localId}
      locale={locale}
      onInitialRender={onInitialRender}
      product={FORGE_PRODUCT}
      workspaceId={workspaceId!}
    />
  );
};
